import axios from 'axios';

import { getItem, removeItem, setItem } from './local-storage.service';

async function signIn(payload) {
  const { data } = await axios.post(`${import.meta.env.VITE_API_URL}/api/auth/sign-in`, payload);
  return data;
}

async function firstSignIn(payload) {
  const { data } = await axios.post(`${import.meta.env.VITE_API_URL}/api/auth/first-sign-in`, payload);
  return data;
}

function signOut() {
  removeItem('accessToken');
  removeItem('refreshToken');
  return axios.get(`${import.meta.env.VITE_API_URL}/api/auth/sign-out`);
}

function testToken() {
  return axios.get(`${import.meta.env.VITE_API_URL}/api/auth/test-token`);
}

async function refreshTokens() {
  const { data } = await axios.post(`${import.meta.env.VITE_API_URL}/api/auth/refresh-token`, {
    refreshToken: getItem('refreshToken'),
  });

  setItem('accessToken', data.accessToken);
  return data;
}

function forgotPassword(email) {
  return axios.post(`${import.meta.env.VITE_API_URL}/api/auth/forgot-password`, {
    email,
  });
}

function resetPassword(email, code, password) {
  return axios.post(`${import.meta.env.VITE_API_URL}/api/auth/reset-password`, {
    email,
    code,
    password,
  });
}

export {
  firstSignIn,
  forgotPassword,
  refreshTokens,
  resetPassword,
  signIn,
  signOut,
  testToken,
};